import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const PURCHASES = [{
  name: 'María García',
  city: 'Buenos Aires'
}, {
  name: 'Carlos Rodríguez',
  city: 'Córdoba'
}, {
  name: 'Ana Martínez',
  city: 'Rosario'
}, {
  name: 'Juan Pérez',
  city: 'Mendoza'
}, {
  name: 'Sofía López',
  city: 'La Plata'
}, {
  name: 'Lucas Fernández',
  city: 'Mar del Plata'
}, {
  name: 'Valentina Díaz',
  city: 'Tucumán'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showRandomPurchase();
    }, 5000);
    const showRandomPurchase = () => {
      const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
      setCurrentPurchase(randomPurchase);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      // Schedule next popup (random time between 15-30 seconds)
      const nextTime = Math.random() * 15000 + 15000;
      setTimeout(showRandomPurchase, nextTime);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-18">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50
    }} className="fixed bottom-4 left-4 z-40 bg-white rounded-lg shadow-xl p-4 max-w-xs border-l-4 border-green-500 flex items-center gap-3" data-id="element-19">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-20">
            <CheckCircle className="w-6 h-6 text-green-600" data-id="element-21" />
          </div>
          <div data-id="element-22">
            <p className="text-sm font-bold text-gray-900" data-id="element-23">
              {currentPurchase.name}
            </p>
            <p className="text-xs text-gray-600" data-id="element-24">
              acaba de comprar desde{' '}
              <span className="font-semibold" data-id="element-25">{currentPurchase.city}</span>
            </p>
            <p className="text-xs text-gray-400 mt-1" data-id="element-26">Hace unos segundos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}